import { createComponent } from '@lit/react';
import React from 'react';
import { SDSStepperStep } from '../sds-stepper-step/sds-stepper-step';

export const SDSStepperStepWrapper = createComponent({
	tagName: 'sds-stepper-step',
	elementClass: SDSStepperStep,
	react: React,
	events: {},
});
